// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3eixe","footer":"Form_footer__3PDnK"};